import { createTRPCContext } from "@trpc/tanstack-react-query";
import type { inferRouterOutputs } from "@trpc/server";
// Type-only import: the server's router type crosses the package boundary so
// the client is checked against the real API, but no server code is bundled.
import type { AppRouter } from "../../../server/src/routers/index.js";

export const { TRPCProvider, useTRPC } = createTRPCContext<AppRouter>();
export type { AppRouter };

/**
 * What each endpoint actually returns.
 *
 * Pages used to re-declare these shapes by hand and cast to them, which meant
 * TypeScript checked the cast against the copy rather than against the API —
 * so renaming a server field went unnoticed until the page rendered
 * `undefined`. Derive from the router instead and a mismatch is a build error.
 */
export type RouterOutput = inferRouterOutputs<AppRouter>;
